// src/features/fourlink-config/components/blocks/Block2Steps/MatrizTipologiasActivos.jsx

import React from 'react';

export const MatrizTipologiasActivos = ({
  selectedTipologias,
  selectedActivos,
  activosConfig,
  tipologiaActivoMatrix,
  onToggleTipologiaActivoSelection,
}) => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Matriz de Tipologías y Activos</h2>
      <p className="text-gray-600 mb-6">Selecciona qué activos aplican para cada tipología de centro:</p>
      
      <div className="space-y-6">
        {selectedTipologias.length === 0 ? (
          <div className="text-center py-8 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-yellow-700">No hay tipologías seleccionadas</p>
          </div>
        ) : (
          selectedTipologias.map(tipologia => (
            <div key={tipologia} className="border rounded-lg p-6 bg-white">
              <h3 className="text-lg font-semibold text-blue-700 mb-4">{tipologia}</h3>
              
              {selectedActivos.length === 0 ? (
                <div className="text-center py-4 text-gray-500 italic">
                  No hay activos seleccionados en el paso anterior
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {selectedActivos.map(activo => {
                      const isSelected = tipologiaActivoMatrix[`${tipologia}-${activo}`] || false;
                      const activoConfigData = activosConfig[activo] || {};
                      
                      return (
                        <div key={activo} className="border rounded-lg p-4 bg-gray-50 hover:bg-gray-100 transition-colors">
                          <label className="flex items-start gap-3 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={() => onToggleTipologiaActivoSelection(tipologia, activo)}
                              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 mt-1"
                            />
                            <div className="flex-1">
                              <h4 className="font-medium text-gray-800 mb-2">{activo}</h4>
                              
                              {isSelected && (
                                <div className="space-y-2">
                                  {activoConfigData.unidad && (
                                    <div className="text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded">
                                      Unidad: {activoConfigData.unidad}
                                    </div>
                                  )}
                                  {(activoConfigData.min || activoConfigData.max) && (
                                    <div className="text-xs text-green-600 bg-green-50 px-2 py-1 rounded">
                                      Rango: {activoConfigData.min || '___'} - {activoConfigData.max || '___'}
                                    </div>
                                  )}
                                  {activoConfigData.planes && activoConfigData.planes.length > 0 && (
                                    <div className="text-xs text-purple-600 bg-purple-50 px-2 py-1 rounded">
                                      {activoConfigData.planes.length} plan{activoConfigData.planes.length !== 1 ? 'es' : ''} asociado{activoConfigData.planes.length !== 1 ? 's' : ''}
                                    </div>
                                  )}
                                </div>
                              )}
                              
                              {isSelected && !activoConfigData.unidad && !activoConfigData.min && !activoConfigData.max && (!activoConfigData.planes || activoConfigData.planes.length === 0) && (
                                <div className="text-xs text-yellow-600 bg-yellow-50 px-2 py-1 rounded">
                                  Sin plan asociado
                                </div>
                              )}
                            </div>
                          </label>
                        </div>
                      );
                    })}
                  </div>
                  
                  <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                    <div className="flex items-center justify-between text-sm">
                      <span className="font-medium text-blue-800">Activos asignados a {tipologia}:</span>
                      <span className="text-blue-600 font-bold">
                        {selectedActivos.filter(activo => tipologiaActivoMatrix[`${tipologia}-${activo}`]).length} de {selectedActivos.length}
                      </span>
                    </div>
                    
                    {selectedActivos.filter(activo => tipologiaActivoMatrix[`${tipologia}-${activo}`]).length > 0 && (
                      <div className="mt-2 text-xs text-blue-700">
                        <strong>Activos seleccionados:</strong> {' '}
                        {selectedActivos
                          .filter(activo => tipologiaActivoMatrix[`${tipologia}-${activo}`])
                          .join(', ')}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          ))
        )}
      </div>
      
      {selectedTipologias.length > 0 && selectedActivos.length > 0 && (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Resumen de Matriz Tipología-Activos</h3>
          
          <div className="overflow-x-auto">
            <table className="w-full text-sm border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Tipología</th>
                  {selectedActivos.map((activo) => (
                    <th key={activo} className="border border-gray-300 px-2 py-2 text-center font-semibold min-w-[80px]">
                      {activo}
                    </th>
                  ))}
                  <th className="border border-gray-300 px-3 py-2 text-center font-semibold">Total</th>
                </tr>
              </thead>
              <tbody>
                {selectedTipologias.map(tipologia => {
                  const activosAsignados = selectedActivos.filter(activo => tipologiaActivoMatrix[`${tipologia}-${activo}`]);
                  return (
                    <tr key={tipologia} className="hover:bg-gray-50">
                      <td className="border border-gray-300 px-3 py-2 font-medium">{tipologia}</td>
                      {selectedActivos.map((activo) => (
                        <td key={activo} className="border border-gray-300 px-2 py-2 text-center">
                          {tipologiaActivoMatrix[`${tipologia}-${activo}`] ? (
                            <span className="text-green-600 font-bold" title="Asignado">
                              <svg className="w-5 h-5 inline-block" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                              </svg>
                            </span>
                          ) : (
                            <span className="text-gray-300">—</span>
                          )}
                        </td>
                      ))}
                      <td className="border border-gray-300 px-3 py-2 text-center font-bold text-blue-600">
                        {activosAsignados.length}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          
          <div className="mt-4 grid grid-cols-2 gap-4">
            <div className="text-center p-3 bg-white rounded border">
              <div className="text-2xl font-bold text-green-600">
                {selectedTipologias.filter(tip => 
                  selectedActivos.some(act => tipologiaActivoMatrix[`${tip}-${act}`])
                ).length}
              </div>
              <div className="text-xs text-green-700">Tipologías con activos</div>
            </div>
            <div className="text-center p-3 bg-white rounded border">
              <div className="text-2xl font-bold text-orange-600">
                {selectedActivos.filter(act => 
                  selectedTipologias.some(tip => tipologiaActivoMatrix[`${tip}-${act}`])
                ).length}
              </div>
              <div className="text-xs text-orange-700">Activos asignados</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};